import React from "react";
import { Link } from "react-router-dom";
import "../css/Footer.css";

import phoneIcon from "../images/phone.png";
import whatsappIcon from "../images/whatsapp.png";
import instagramIcon from "../images/instapng.webp";
import emailIcon from "../images/mail.png";
import facebookIcon from "../images/facebook.png";
import logo from "../images/mindsparklogo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ms-footer">
      {/* ==================================================
          DECORATIVE BACKGROUND
      ================================================== */}

      <div className="ms-footer-grid" />

      <div className="ms-footer-glow ms-footer-glow-blue" />
      <div className="ms-footer-glow ms-footer-glow-yellow" />

      {/* ==================================================
          TOP CTA
      ================================================== */}

      <div className="container ms-footer-container">
        <div className="ms-footer-cta">
          <div className="ms-footer-cta-content">
            <div className="ms-footer-cta-icon">
              ✦
            </div>

            <div>
              <span className="ms-footer-cta-label">
                LEARNING THROUGH TECHNOLOGY
              </span>

              <h2>
                Let’s build future-ready learners together.
              </h2>

              <p>
                Connect with MindSpark to bring hands-on
                Robotics, AI, Coding and STEM learning to
                students.
              </p>
            </div>
          </div>

          <a
            href="https://forms.gle/MgUEEdZtwJtLwTjY8"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-footer-cta-button"
          >
            Partner With Us

            <span>→</span>
          </a>
        </div>

        {/* ==================================================
            MAIN FOOTER
        ================================================== */}

        <div className="ms-footer-main">
          {/* ================================================
              BRAND
          ================================================ */}

          <div className="ms-footer-brand">
            <Link
              to="/"
              className="ms-footer-logo-link"
              aria-label="MindSpark Home"
            >
              <div className="ms-footer-logo-box">
                <img
                  src={logo}
                  alt="MindSpark EduTech"
                  className="ms-footer-logo"
                />
              </div>
            </Link>

            <div className="ms-footer-brand-copy">
              <span>
                MINDSPARK EDUTECH
              </span>

              <h3>
                Learning Through Technology.
              </h3>

              <p>
                Creating engaging technology learning
                experiences through Robotics, AI, Coding
                and hands-on STEM education.
              </p>
            </div>

            {/* SOCIAL ICONS */}
            <div className="ms-footer-socials">
              <a
                href="https://www.instagram.com/mind_sparkedutech"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="MindSpark Instagram"
              >
                <img
                  src={instagramIcon}
                  alt=""
                  aria-hidden="true"
                />
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61573248045579&mibextid"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="MindSpark Facebook"
              >
                <img
                  src={facebookIcon}
                  alt=""
                  aria-hidden="true"
                />
              </a>

              <a
                href="https://wa.me/9356214544"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact MindSpark on WhatsApp"
              >
                <img
                  src={whatsappIcon}
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>

          {/* ================================================
              QUICK LINKS
          ================================================ */}

          <div className="ms-footer-column">
            <div className="ms-footer-column-heading">
              <span />
              Explore
            </div>

            <nav
              className="ms-footer-links"
              aria-label="Footer navigation"
            >
              <Link to="/">
                <span>Home</span>
                <i>↗</i>
              </Link>

              <Link to="/temp-school">
                <span>Our Network</span>
                <i>↗</i>
              </Link>

              <Link to="/about-us">
                <span>About Us</span>
                <i>↗</i>
              </Link>

              <Link to="/careers">
                <span>Careers</span>
                <i>↗</i>
              </Link>
            </nav>
          </div>

          {/* ================================================
              CONTACT
          ================================================ */}

          <div className="ms-footer-column">
            <div className="ms-footer-column-heading">
              <span />
              Contact Us
            </div>

            <div className="ms-footer-contact-list">
              <a
                href="tel:+919356214544"
                className="ms-footer-contact"
              >
                <div className="ms-footer-contact-icon yellow">
                  <img
                    src={phoneIcon}
                    alt=""
                    aria-hidden="true"
                  />
                </div>

                <div>
                  <small>
                    CALL US
                  </small>

                  <strong>
                    +91 93562 14544
                  </strong>
                </div>
              </a>

              <a
                href="https://wa.me/9356214544"
                target="_blank"
                rel="noopener noreferrer"
                className="ms-footer-contact"
              >
                <div className="ms-footer-contact-icon teal">
                  <img
                    src={whatsappIcon}
                    alt=""
                    aria-hidden="true"
                  />
                </div>

                <div>
                  <small>
                    WHATSAPP
                  </small>

                  <strong>
                    Chat with MindSpark
                  </strong>
                </div>
              </a>

              <a
                href="mailto:outreachmindsparkedutech@gmail.com"
                className="ms-footer-contact"
              >
                <div className="ms-footer-contact-icon blue">
                  <img
                    src={emailIcon}
                    alt=""
                    aria-hidden="true"
                  />
                </div>

                <div>
                  <small>
                    EMAIL
                  </small>

                  <strong className="ms-footer-email">
                    outreachmindsparkedutech@gmail.com
                  </strong>
                </div>
              </a>
            </div>
          </div>

          {/* ================================================
              OFFICE
          ================================================ */}

          <div className="ms-footer-column ms-footer-office">
            <div className="ms-footer-column-heading">
              <span />
              Pune Office
            </div>

            <p className="ms-footer-address">
              301, 4th Floor, Trimurti Honey Gold,
              Ashok Nagar, Range Hill Rd, above Axis Bank,
              Shivajinagar, Pune, Maharashtra 411016
            </p>

            <div className="ms-footer-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3423.15486989255!2d73.8378797!3d18.5420358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf3d74f48a87%3A0x864bef756eca4647!2sAster%20Coworking!5e1!3m2!1sen!2sus!4v1762955584299!5m2!1sen!2sus"
                title="MindSpark Pune office location"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>

        {/* ==================================================
            PROGRAM STRIP
        ================================================== */}

        <div className="ms-footer-program-strip">
          <span className="yellow">
            Robotics
          </span>

          <i />

          <span className="purple">
            Artificial Intelligence
          </span>

          <i />

          <span className="blue">
            Coding
          </span>

          <i />

          <span className="teal">
            Hands-on STEM
          </span>
        </div>

        {/* ==================================================
            COPYRIGHT
        ================================================== */}

        <div className="ms-footer-bottom">
          <p>
            © {currentYear} MindSpark EduTech Pvt. Ltd.
            All rights reserved.
          </p>

          <div className="ms-footer-bottom-brand">
            <span className="ms-footer-status-dot" />

            Learning Through Technology
          </div>
        </div>
      </div>
    </footer>
  );
}
